<template>
	<div class="card mb-4">
    <template v-if="!$checkMetamask() || accounts.length == 0 ">
      <div class="switchNetwork-layer">
        <span @click="$connectMetamask()" class="btn btn-primary">CONNECT WALLET</span>
      </div>
    </template>
    <template v-else-if="switchNetwork">
      <div class="switchNetwork-layer">
        <span class="btn btn-primary" data-toggle="modal" data-target="#SwapChainList">SWITCH NETWORK</span>
      </div>
    </template>
		<div class="card-body">    
      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center mb-3">
          <h2 class="h5 mb-0 font-size-125 font-family-krona">Swap</h2>
          <div class="actions">
            <a class="" href="javascript:void(0)" @click="loadUSDTValues()"><font-awesome-icon :icon="['fas', 'redo-alt']" /></a>
            <a class="ml-3" href="javascript:void(0)"><font-awesome-icon :icon="['fas', 'sliders-h']" /></a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-if="errorTransaction" class="alert alert-danger">Transaction error. Try it again.</div>
          <div v-if="errorInsufficientAssetLiquidity" class="alert alert-danger">Invalid Transaction. Insufficient asset liquidity.</div>
          <div id="form" class="mx-3">
            <div class="position-relative">
              <div class="row">
                <div class="col-12 swapbox-gray py-2 mb-3">
                  <div class="swapbox">
                    <div class="row">
                      <div class="col-4">
                        <p class="text-muted m-0 w-100 uppertext font-size-080">You pay</p>
                      </div>
                      <div class="col-8">
                        <p class="text-muted m-0 w-100 uppertext font-size-080 text-right">Balance: {{$formatNumber(balanceFrom)}}<a href="javascript:void(0)" @click="setMaxQuantity()" class="ml-1 cursor-pointer font-weight-bold text-decoration-none">MAX</a></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-7 d-flex align-items-center">
                        <div class="swapbox_select w-100 my-1" id="from_token_select">
                          <div class="d-flex align-items-center token_select" @click="setOrigin('from')" data-toggle="modal" data-target="#TokensList">
                            <span v-if="!tokenFrom">SELECT A TOKEN</span>
                            <template v-else>
                              <img class="mr-2" height="24" :src="tokenFrom.logo" alt="bnb"/>
                              <span class="font-size-125">{{tokenFrom.symbol}}</span>
                            </template>
                            <span class="text-muted font-size-080 ml-2"><font-awesome-icon :icon="['fas', 'chevron-down']"/></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <div class="swapbox_select w-100 my-1">
                          <input @blur="swapPrice();" class="number form-control text-right border-0 bg-transparent p-0" placeholder="0" id="from_amount" v-model="amount_token_from">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <p class="text-muted m-0 w-100 uppertext font-size-080">{{tokenFrom.name}}</p>
                      </div>
                      <div class="col-8">
                        <p class="text-muted m-0 w-100 uppertext font-size-080 text-right">~${{$formatNumber(tokenFromValue)}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="{'swapbox-arrow-reverse': flagSwapDirection}" @click="swapReverse()" class="swapbox-arrow rounded-circle border p-2 position-absolute d-flex align-items-center">
                <a href="javascript:void(0)" class="text-primary">
                  <font-awesome-icon :icon="['fas', 'arrow-down']"/>
                </a>
              </div>
              <div class="row">
                <div class="col-12 border py-2 mb-3">
                  <div class="swapbox">
                    <div class="row">
                      <div class="col-6">
                        <p class="text-muted m-0 w-100 uppertext font-size-080">You receive</p>
                      </div>
                      <div class="col-6">
                        <p class="text-muted m-0 w-100 uppertext font-size-080 text-right">Balance: {{$formatNumber(balanceTo)}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-7 d-flex align-items-center">
                        <div class="swapbox_select w-100 my-1" id="to_token_select">
                          <div class="d-flex align-items-center token_select" @click="setOrigin('to')" data-toggle="modal" data-target="#TokensList">
                            <span v-if="!tokenTo">SELECT A TOKEN</span>
                            <template v-else>
                              <img class="mr-2" height="24" :src="tokenTo.logo" alt="bnb"/>
                              <span class="font-size-125">{{tokenTo.symbol}}</span>
                            </template>
                            <span class="text-muted font-size-080 ml-2"><font-awesome-icon :icon="['fas', 'chevron-down']"/></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <div class="swapbox_select w-100 my-1">
                          <input class="number form-control text-right border-0 bg-transparent p-0" placeholder="0" id="from_amount" readonly v-model="amount_token_to" @blur="swapPrice();">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="text-muted m-0 w-100 uppertext font-size-080">{{tokenTo.name}}</p>
                      </div>
                      <div class="col-6">
                        <p class="text-muted m-0 w-100 uppertext font-size-080 text-right">~${{$formatNumber(tokenToValue)}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="checkForm">
              <div class="col-12 border py-2 mb-3">
                <div class="swapbox font-size-075 white-space-nowrap">
                  <div class="row">
                    <div class="col-9">
                      1 {{ tokenFrom.symbol }} = <span v-html="$fixPrice(grossPrice,tokenFrom.decimalsDisplay)"></span> {{ tokenTo.symbol }} <span class="text-muted">(~$<span v-html="$fixPrice(grossPriceUSDT,tokenFrom.decimalsDisplay)"></span>)</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      Price impact
                    </div>
                    <div class="col-6 text-right">
                      {{ priceImpact }}%
                    </div>
                  </div>
                  <div class="row" v-if="feeAmount > 0">
                    <div class="col-6">
                      Trading Fee
                    </div>
                    <div class="col-6 text-right">
                      <span v-html="$fixPrice($convertFromBaseUnits(feeAmount,tokenTo.decimals),tokenTo.decimalsDisplay)"></span> {{tokenTo.symbol}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <button v-if="chainSelected" v-bind:class="{ disabled: !checkForm }" :disabled="!checkForm" class="btn btn-large btn-primary btn-block" id="swap_button" @click="trySwap()">
                <span v-if="!loadingTransaction">Swap</span>
                <span v-else><img src="@/assets/loader.svg" height="20" alt=""> Pending</span>
              </button>
            </div>               
          </div>
        </div>
      </div>
    </div>

    <TokensList v-if="!switchNetwork" :id="'TokensList'" :modalTitle="'Select a token'" :classes="'p-0'" @tokenSelected="tokenSelected($event)" :origin="origin" :chain="chainSelected" :tokenFromSelected="tokenFrom" :tokenToSelected="tokenTo"></TokensList>
	</div>
</template>

<script>
  
import Web3 from 'web3';
import axios from 'axios';
import TokensList from './templates/TokensList.vue'
import chains from '../../../../data/chains.json'
import BigNumber from 'bignumber.js'
import swapTokens from '../../../../data/swapTokens.json'

export default {
  name: 'Home',
  data() {
    return {
      accounts: '',
      balance: '',
      balanceTo: 0,
      balanceFrom: 0,
      web3: '',
      tokens: {},
      tokenFrom: '',
      tokenTo: '',
      tokenFromValue: 0,
      tokenToValue: 0,
      amount_token_from: 0,
      amount_token_to: 0,
      origin: '',
      gas_estimate: '',
      chainsAvailables: chains,
      chainSelected: {
        "id":"eth",
        "name":"ETH",
        "chain":"0x1",
        "apiTransactionsURL":"https://api.0x.org",
        "logo":"https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        "rpcUrls":"https://mainnet.infura.io/v3/",
        "nativeCurrency": {
          "name": "ETH",
          "symbol": "ETH",
          "decimals": 18
        },
        "blockExplorerUrls":"https://etherscan.io",
        "coinmarketcapSlug":"ethereum",
        "enabled": true
      },
      errorTransaction: false,
      loadingTransaction: false,
      errorInsufficientAssetLiquidity: false,
      flagSwapDirection: false,
      grossPrice: 0,
      grossPriceUSDT: 0,
      tokenUSDT: '',
      tokenUSDC: '',
      priceImpact: 0,
      feeAmount: 0,
      switchNetwork: false
    };
  },
  computed :{
    checkForm: function() {
      return this.tokenTo && this.tokenFrom && this.amount_token_to && this.amount_token_from;
    }
  },
  components: {
    TokensList
  },
  async created() {
    if(this.$checkMetamask()){
      if(this.chainSelected !== ''){
        this.web3 = new Web3(Web3.givenProvider)
        this.getBalance("0xaba9db5fbfa59efbb087cd3e1409c49e73c85782");
        await this.setChain();
        this.$getAccountsMetamask().then((result) => {
          this.accounts = result
        });

        this.initUSDT();
        this.initUSDC();
        this.$emit('widgetLoaded');
      }
    }

    let vm = this;

    window.ethereum.on('chainChanged', function(chainId){
      vm.setChain();
    });
  },
  updated(){
    if(this.$checkMetamask()){
      this.$getAccountsMetamask().then((result) => {
        this.accounts = result
      });
    }
  },
  methods: {
    //comprubea si metamask esta contectada
    //obtiene el balance de eth de tu cuenta. NO FUNCIONA AUN
    getBalance(address) {
      this.web3.eth.getBalance(address).then(result => this.balance = result);
    },

    getChainId(){
      return window.ethereum.request({
        method: 'eth_chainId',
      });
    },
    async setChain(){
      let currentMetamaskNetwork = await this.getChainId();
      let metamaskChain = this.chainsAvailables.filter((chain) => chain.chain == currentMetamaskNetwork && chain.enabled)
      if(metamaskChain.length > 0){
        this.chainSelected = metamaskChain[0];
      }
      else{
        this.chainSelected = {
          "id":"eth",
          "name":"ETH",
          "chain":"0x1",
          "apiTransactionsURL":"",
          "logo":"",
          "rpcUrls":"",
          "nativeCurrency": {
            "name": "",
            "symbol": "",
            "decimals": ""
          },
          "blockExplorerUrls":"",
          "coinmarketcapSlug":""
        }
      }
      
      this.tokenTo = '';
      this.tokenFrom = '';
      this.amount_token_to = 0;
      this.amount_token_from = 0;
      this.balanceTo = 0;
      this.balanceFrom = 0;
      this.checkChain();
    },
    initUSDT(){
      let tokenUSDT = swapTokens.tokens[this.chainSelected.id].filter((token) => token.symbol == 'USDT' );

      this.tokenUSDT = tokenUSDT[0];
    },
    initUSDC(){
      let tokenUSDC = swapTokens.tokens[this.chainSelected.id].filter((token) => token.symbol == 'USDC' );

      this.tokenUSDC = tokenUSDC[0];
    },
    async getBalanceTo(){
      this.balanceTo = await this.$getToken(this.tokenTo,this.accounts[0]);
    },
    async getBalanceFrom(){
      this.balanceFrom = await this.$getToken(this.tokenFrom,this.accounts[0]);
    },
    async swapPrice(origin) {

      this.errorInsufficientAssetLiquidity = false;

      let buyToken = this.tokenTo.symbol;
      let sellToken = this.tokenFrom.symbol;

      let sellAmount = this.$convertToBaseUnits(this.amount_token_from,this.tokenFrom.decimals);
      let buyAmount = this.$convertToBaseUnits(this.amount_token_to,this.tokenTo.decimals);

      if((this.tokenFrom && sellAmount > 0 && this.tokenTo) || (this.tokenTo && buyAmount > 0 && this.tokenFrom)){

        this.getPrice(this.tokenFrom.address, this.tokenTo.address, sellAmount)
          .then((response) => {
            this.amount_token_to = this.$convertFromBaseUnits(response.buyAmount,this.tokenTo.decimals);
            this.amount_token_from = this.$convertFromBaseUnits(response.grossSellAmount,this.tokenFrom.decimals);

            this.amount_token_to = parseFloat(this.amount_token_to).toFixed(this.tokenTo.decimalsDisplay);


            this.grossPrice = response.grossPrice;
            this.priceImpact = response.estimatedPriceImpact;
            if(response.fees.zeroExFee != null){
              this.feeAmount = response.fees.zeroExFee.feeAmount;
            }
            this.loadUSDTValues();
          })
          .catch((error) => {
            console.log(error);
            if(error.validationErrors[0].reason == 'INSUFFICIENT_ASSET_LIQUIDITY'){
              this.errorInsufficientAssetLiquidity = true;
            }
          });
      }
    },
    async getPrice(sellToken, buyToken, sellAmount, buyAmount){
      return new Promise((resolve, reject) => {
        let query = `?buyToken=${buyToken}&sellToken=${sellToken}`;

        if(sellAmount && sellAmount > 0){
          query += `&sellAmount=${sellAmount}`
        }

        if(buyAmount && buyAmount > 0){
          query += `&buyAmount=${buyAmount}`
        }

        axios.get(`${this.chainSelected.apiTransactionsURL}/swap/v1/price${query}`,{
            headers: {
              '0x-api-key': '9a66321c-087b-4a13-a146-904e3e3f5a9c'
            }
          })

          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });

    },
    setOrigin(value){
      this.origin = value;
    },
    tokenSelected(event) {
      if(event.origin == 'from'){
        this.tokenFrom = event.token
        this.getBalanceFrom();
      }
      else{
        this.tokenTo = event.token;
        this.getBalanceTo();
      }
      this.swapPrice(event.origin);
    },
    async getQuote(account){
      console.log("Getting Quote");

      let swapQuoteJSON;

      if (!this.tokenFrom.address || !this.tokenTo.address || !this.amount_token_from) return;

      let amount = this.$convertToBaseUnits(this.amount_token_from,this.tokenFrom.decimals);

      const params = {
        sellToken: this.tokenFrom.address,
        buyToken: this.tokenTo.address,
        sellAmount: amount,
        // Set takerAddress to account
        takerAddress: account
      }

      const headers = {'0x-api-key': '9a66321c-087b-4a13-a146-904e3e3f5a9c'}; // This is a placeholder. Get your live API key from the 0x Dashboard (https://dashboard.0x.org/apps)

      // Fetch the swap quote.
      const response = await fetch(
        `${this.chainSelected.apiTransactionsURL}/swap/v1/quote?sellToken=${params.sellToken}&buyToken=${params.buyToken}&sellAmount=${params.sellAmount}&feeRecipient=0xAbA9DB5FBfA59efBB087CD3e1409c49E73C85782&buyTokenPercentageFee=0.5&feeRecipientTradeSurplus=0xAbA9DB5FBfA59efBB087CD3e1409c49E73C85782`,{headers});


      swapQuoteJSON = await response.json();
      console.log("Quote: ", swapQuoteJSON);

      this.amount_token_to = swapQuoteJSON.buyAmount / (10 ** this.tokenTo.decimals);
      this.gas_estimate = swapQuoteJSON.estimatedGas;

      return swapQuoteJSON;
    },
    async trySwap() {
      // The address, if any, of the most recently used account that the caller is permitted to access
      this.loadingTransaction = true;
      let accounts = await window.ethereum.request({ method: "eth_accounts" });
      let takerAddress = this.accounts[0];
      // Log the the most recently used address in our MetaMask wallet
      console.log("takerAddress: ", takerAddress);
      // Pass this as the account param into getQuote() we built out earlier. This will return a JSON object trade order.
      const swapQuoteJSON = await this.getQuote(takerAddress);

      const erc20abi= [{ "inputs": [ { "internalType": "string", "name": "name", "type": "string" }, { "internalType": "string", "name": "symbol", "type": "string" }, { "internalType": "uint256", "name": "max_supply", "type": "uint256" } ], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Transfer", "type": "event" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" } ], "name": "allowance", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "approve", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "account", "type": "address" } ], "name": "balanceOf", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "burnFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [ { "internalType": "uint8", "name": "", "type": "uint8" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" } ], "name": "decreaseAllowance", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" } ], "name": "increaseAllowance", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "transfer", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "transferFrom", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }]
      // Set up approval amount for the token we want to trade from
      const fromTokenAddress = this.tokenFrom.address;

      const  web3 = new  Web3(Web3.givenProvider);
      const ERC20TokenContract = new web3.eth.Contract(erc20abi, fromTokenAddress);
      console.log("setup ERC20TokenContract: ", ERC20TokenContract);

      const maxApproval = new BigNumber(2).pow(256).minus(1);
      console.log("approval amount: ", maxApproval);

      const tx = await ERC20TokenContract.methods.approve(
        swapQuoteJSON.allowanceTarget,
        maxApproval,
      )
      .send({ from: takerAddress })
      .then(tx => {
        console.log("tx: ", tx)
      })
      .catch((error) => {
        switch(error.code){
          case 4001:
            this.loadingTransaction = false;
            console.log(error);
            break;
        }
      });

      swapQuoteJSON.from = takerAddress;
      const  receipt = await  web3.eth.sendTransaction(swapQuoteJSON).then((receipt) => {
        console.log(receipt)
        this.loadingTransaction = false;
        this.getBalanceTo();
      })
      .catch((error) => {
        console.log(error);
        this.loadingTransaction = false;
      });
      console.log("receipt: ", receipt);
    },
    loadUSDTValues(){

      let sellAmount = this.$convertToBaseUnits(this.amount_token_from,this.tokenFrom.decimals);

      let tokenBuy =   this.tokenFrom.symbol == this.tokenUSDT.symbol || this.tokenTo.symbol == this.tokenUSDT.symbol ? this.tokenUSDC : this.tokenUSDT;


      this.getPrice(this.tokenFrom.address, tokenBuy.address, sellAmount)
        .then((responseFromUSDT)=>{
          this.tokenFromValue = this.$convertFromBaseUnits(responseFromUSDT.buyAmount,tokenBuy.decimals);
        })  
      this.getPrice(this.tokenTo.address, tokenBuy.address, this.$convertToBaseUnits(this.amount_token_to,this.tokenTo.decimals))
        .then((responseFromUSDT)=>{
          this.tokenToValue = this.$convertFromBaseUnits(responseFromUSDT.buyAmount,tokenBuy.decimals);
        })
      this.getPrice(this.tokenFrom.address, tokenBuy.address, this.$convertToBaseUnits(1 ,this.tokenFrom.decimals))
        .then((responseFromUSDT)=>{
          this.grossPriceUSDT = this.$convertFromBaseUnits(responseFromUSDT.buyAmount,tokenBuy.decimals);
        })  
    },
    swapReverse(){
      this.flagSwapDirection = !this.flagSwapDirection;
      let balanteToAux = this.balanceTo;
      let tokenToAux = this.tokenTo;
      let amount_token_to_aux = this.amount_token_to;
      let tokenToValueAux = this.tokenToValue;

      console.log(this.tokenFrom);

      this.balanceTo = this.balanceFrom;
      this.tokenTo = this.tokenFrom;
      this.amount_token_to = this.amount_token_from;
      this.tokenToValue = this.tokenFromValue;

      this.balanceFrom = balanteToAux;
      this.tokenFrom = tokenToAux;
      this.amount_token_from = amount_token_to_aux;
      this.tokenFromValue = tokenToValueAux;
      this.swapPrice();
    },
    setMaxQuantity(){
      this.amount_token_from = this.balanceFrom;
      this.swapPrice();
    },
    async checkChain(){
      let currentMetamaskNetwork = await this.getChainId();
      let checkChain = this.chainsAvailables.filter((chain) => chain.chain == currentMetamaskNetwork && chain.enabled)

      if(checkChain.length > 0){
        this.switchNetwork = false;
      }
      else{
        this.switchNetwork = true;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.swapbox-gray{
  background: #191c20;
}
.swapbox_select input{
  font-weight:400;
  font-size:1.5rem;
  height:auto;

  &:focus,&:active,&:hover{
    box-shadow:0 0 0;
  }
}

.swapbox-arrow{
  height: 28px;
  width: 28px;
  top: 50%;
  left: 50%;
  margin-top: -22px;
  background: #0b0c0e;
  justify-content: center;
  z-index: 9;
  margin-left: -12px;
  box-shadow: 0 0 4px rgba(71, 73, 79, .1), 0 1px 2px rgba(71, 73, 79, .25);
  transition: 0.1s 0s linear;

  &.swapbox-arrow-reverse{
    rotate: -180deg;
  }
}

.token_select{
  cursor:pointer;
}

.switchNetwork-layer{
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
}

</style>
